export const haltsMutationKeys = {
  haltAll: (params: { teamId: string }) => ['halts', params] as const
}
